// @flow

import styled, { css } from 'styled-components';
import { media } from '../../../helpers';
import type { Theme } from '../../../types';

export default styled<any, Theme>('div')`
  color: ${props => props.theme.pdbInfo.mileageAndDuration.color};
  font-size: ${props => props.theme.pdbInfo.mileageAndDuration.fontSize.default};
  ${media.lg(css`
    font-size: ${props => props.theme.pdbInfo.mileageAndDuration.fontSize.lg};
  `)}

  span {
    display: inline;
  }
`;
